<app-tab-decorticage
    (onDrawerStateChange)="onOpenedChange($event)"
    (onAskSave)="saveAnalysis()"
    #TabAnalysis></app-tab-decorticage>
